export const localStoreStepName = 'coffeeGeneratorLastStep_1';
export const localStoreFormDataName = 'coffeeGeneratorFormData_1';
export const localStoreSelectedCoffeeName = 'coffeeGeneratorSelectedCoffee_1';